export default "https://cdn-static.gokick.com/assets/6ff5832d0d355fee068eb0a1603b37a2d61221c6/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";